import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Typography, Box } from "@material-ui/core";
import useStyles from "../../assets/styles/styles";
import CustomButton from "../../controls/Button/CustomButton";

const ModalCallPatient = ({
    open,
    onClose,
    title,
    callAttempts,
    countdown,
    isButtonDisabled,
    handleEnter,
    handleRetry,
}) => {
    const classes = useStyles();
    const remainingAttempts = 3 - callAttempts;


    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            id="backDropActivities"
        >
            <Box id="modalCallPatientContainer">
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>

                <DialogTitle
                    id="modal-call-patient-title"
                    className={classes.contentDialogTitleCallModel}
                >
                    <Typography
                        className={classes.titleDialogActivitiesCallModal}
                    >
                        {title}
                    </Typography>
                </DialogTitle>

                <DialogContent
                    className={`${classes.contentDialogTitleCallModel} ${classes.contentDialogCallModel}`}
                >
                    <Typography className={classes.txtModalCall}>
                        Aguarde unos instantes
                    </Typography>
                    <Typography className={classes.txtModalCall}>
                        Puede volver a llamar al paciente hasta ({remainingAttempts}) intentos
                    </Typography>
                    <Box className={`${classes.buttonModalCall}`}>
                        <CustomButton
                            title="Ingresar"
                            className={`${classes.buttonJoinCall} ${classes.lightLinearDark}`}
                            onClick={handleEnter}
                        />
                        <CustomButton
                            title={`Reintentar${isButtonDisabled ? ` (${countdown}s)` : ""}`}
                            className={`${classes.buttonJoinCall} ${classes.lightLinearGradient}`}
                            onClick={handleRetry}
                            disabled={callAttempts >= 3 || isButtonDisabled}
                        />
                        <CustomButton
                            title="Cancelar"
                            className={` ${classes.buttonNotConfirmCall}`}
                            onClick={onClose}
                        />
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>
    );
};

export default ModalCallPatient;
